module.exports = __webpack_public_path__ + "static/media/section_3_B.f70bfc1b.png";